export const notificationSchedulerTime = 60000;
//Amplitude 
export const connectionString = 'dd5d04a2f3b27d0ade5596f2b5371b84';

//Images
export const logo = require('../assets/images/TCS-logo.png');

//Labels
export const printLabel1 = "Thank you for shopping with us!";
export const appTitle = "The Cricket Store";
export const businessAddress = "Royal House, 110 Station Parade, Harrogate HG1 1EP";
export const businessEmail = "info@thecricketstore.uk";
export const businessUrl = "www.thecricketstore.uk";

//Validation messages
export const Messages = {
    validation: {
        isEmpty: "Please fill this field."
    },
}